import { Config } from './EnvironmentConstants'

export const s3UploaderFolderName = {
  profilePic: `${Config.ENVIRONMENT}/media/profile_pic/`
}
